import IcPlus from './IcPlus'
export default IcPlus
